import * as React from 'react';
import { ReactSVG } from 'react-svg';
import Icon from '@material-ui/core/Icon';

import UsersIcon from '../resources/icons/users_page.svg';
// Hidden per request (Reports/Search/Invoices menu items) — restore with the links below.
// import SearchIcon from '../resources/icons/search_page.svg';
import UserPageIcon from '../resources/icons/user_page.svg';
import DashboardIcon from '../resources/icons/home_page.svg';
// import ReportsIcon from '../resources/icons/report_page.svg';
// import InvoiceIcon from '../resources/icons/invoices_page.svg';
import SettingsIcon from '../resources/icons/settings_page.svg';
import ProjectsIcon from '../resources/icons/project_page.svg';
import FranchiseIcon from '../resources/icons/franchise_page.svg';
import useUserRole from '../hooks/useUserRole';

import { SidebarMenuLink } from '../molecules';
import { ROUTES } from '../constants/routes';
import SidebarShell from './AppShell/SidebarShell';

const createIcon = (src: string) => (
  <Icon>
    <ReactSVG src={src} />
  </Icon>
);

const Sidebar = () => {
  const { isEmployee } = useUserRole();

  return (
    <SidebarShell>
      <SidebarMenuLink
        icon={() => createIcon(DashboardIcon)}
        to={ROUTES.DASHBOARD}
        title="Dashboard"
      />
      <SidebarMenuLink
        icon={() => createIcon(SettingsIcon)}
        to={ROUTES.SETTINGS_JURISDICTION}
        activePath={ROUTES.SETTINGS}
        title="Settings"
      />
      {isEmployee && (
        <SidebarMenuLink
          icon={() => createIcon(ProjectsIcon)}
          to={ROUTES.PROJECTS}
          title="Projects"
        />
      )}
      {/* Reports, Search and Invoices hidden per request for super admin and
          branch admin. Routes are left intact — uncomment to restore. */}
      {/* <SidebarMenuLink
        icon={() => createIcon(ReportsIcon)}
        to={ROUTES.REPORTS_SALES}
        title="Reports"
      /> */}
      <SidebarMenuLink
        icon={() => createIcon(FranchiseIcon)}
        to={ROUTES.FRANCHISE}
        title="Branch"
      />
      <SidebarMenuLink
        icon={() => createIcon(UsersIcon)}
        to={ROUTES.USERS}
        title="Users"
      />
      {/* <SidebarMenuLink
        icon={() => createIcon(SearchIcon)}
        to={ROUTES.SEARCH}
        title="Search"
      /> */}
      {/* <SidebarMenuLink
        icon={() => createIcon(InvoiceIcon)}
        to={ROUTES.INVOICES}
        title="Invoices"
      /> */}
      <SidebarMenuLink
        icon={() => createIcon(UserPageIcon)}
        to={ROUTES.ACCOUNT}
        title="Account"
      />
    </SidebarShell>
  );
};

export default Sidebar;
